module.exports = __webpack_public_path__ + "static/media/Squirtle_gaussian2.decdc648.png";